import { theme } from "nectar-ui";
import React from "react";

const ArrowTrendIcon = ({ direction, color }: { direction: "up" | "down", color: string }) => {
  const styleObj = {
    height: theme.standard.spacings.sm,
    fill: theme.standard.colors[color]
  };

  return direction === "up" ? (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" {...styleObj}>
      <path d="M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V205.3L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160H384z" />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" {...styleObj}>
      <path d="M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352H384z" />
    </svg>
  );
};

export default ArrowTrendIcon;
